module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-green-8b4ce804c9922fefeee55f9fd25657a1.svg";